import { Box, SystemProps, Text, UnderlineButton } from "flicket-ui";
import styled from "styled-components";

import { useAtom } from "jotai";
import { Icon } from "~components";

import {
  Details,
  ticketDetailsAtom,
} from "~features/seated-reservation/components/common/modal.TicketDetails";

const ToolTip = styled(Box)<SystemProps>`
  position: relative;

  &&& button:hover {
    color: ${(p) => p.theme.colors.N600};
    opacity: 0.8;
    transition: background 0.2s, box-shadow 0.15s, border-color 0.2s, color 0.2s,
      opacity 0.2s;
  }
`;

type ListItemDetailsProps = Details;

export const ListItemDetails = ({
  name,
  description,
  restrictions,
  addonImage,
  ticketImage,
}: ListItemDetailsProps) => {
  if (!description && !restrictions) {
    return null;
  }

  const [_, setTicketDetails] = useAtom(ticketDetailsAtom);

  return (
    <ToolTip>
      <UnderlineButton
        color="N600"
        onClick={() => {
          //  @ts-expect-error atom type issue while using strict:false
          setTicketDetails({
            name,
            description,
            restrictions,
            addonImage,
            ticketImage,
          });
        }}
      >
        <Icon color="N500" icon="info" fontSize={3} mr="1/2" />
        <Text fontSize={2} fontWeight="medium" lineHeight="medium">
          Details
        </Text>
      </UnderlineButton>
    </ToolTip>
  );
};

export default ListItemDetails;
